// extracted by mini-css-extract-plugin
module.exports = {"decc-form":"DeccPayment_decc-form__PqQfd"};